export default __webpack_public_path__ + "static/P-0423421aa0fb14e7c130710c2908ccc3.png";